import React from "react";
import styles from "./IntroBanner.module.scss";
import heroImg from "../../../../assets/images/hero.webp";
import useTypewriter from "../../../../hooks/useTypeWriter";
import { ReactComponent as GithubIcon } from "../../../../assets/icons/githubIcon.svg";
import { ReactComponent as LinkedInIcon } from "../../../../assets/icons/linkedInIcon.svg";
import { ReactComponent as InstagramIcon } from "../../../../assets/icons/instagramIcon.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/icons/eyeIcon.svg";
import { ReactComponent as MailIcon } from "../../../../assets/icons/mailIcon.svg";

const ROLES = [
  "Full Stack Developer",
  "Mobile App Engineer",
  "React & Node.js Expert",
  "AI Enthusiast",
  "Laravel/ Lumen Developer",
  "UI/UX Enthusiast",
];

export default function IntroBanner() {
  const role = useTypewriter(ROLES);

  return (
    <>
      <section className={styles["hero"]}>
        <div className={styles["h-grid"]}>
          {/*Left side */}
          <div className={styles["h-left"]}>
            <p className={styles["h-greeting"]}>Hi There, 👋</p>
            <h1 className={styles["h-name"]}>
              I'm <span className={styles["h-name-accent"]}>Sreerag V S</span>
              <span className={styles["h-name-underline"]} />
            </h1>

            {/* typewriter */}
            <div className={styles["h-role-row"]}>
              <span className={styles["h-role-pill"]}>Role</span>
              <span className={styles["h-typewriter"]}>
                {role}
                <span className={styles["h-cursor"]} />
              </span>
            </div>

            {/* description */}
            <p className={styles["h-desc"]}>
              A <strong>Full Stack Web &amp; Mobile Developer</strong> with 5+
              years of experience. Dedicated to crafting efficient, scalable,
              and user centric solutions — from requirement analysis to
              deployment and maintenance.
            </p>

            {/* CTAs */}
            <div className={styles["h-cta"]}>
              <a href="#projects" className={styles["h-btn-dark"]}>
                <EyeIcon />
                <span>View My Work</span>
              </a>
              <a href="#contact" className={styles["h-btn-outline"]}>
                <MailIcon />
                Let's Connect
              </a>
            </div>

            {/* socials */}
            <div className={styles["h-socials"]}>
              <a
                href="https://www.github.com/Sreerag-V-S"
                target="_blank"
                rel="noreferrer"
                className={styles["h-social"]}
              >
                <GithubIcon />
              </a>
              <a
                href="https://www.linkedin.com/in/sreerag-v-s"
                target="_blank"
                rel="noreferrer"
                className={styles["h-social"]}
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://www.instagram.com/_sreerag_v_s"
                target="_blank"
                rel="noreferrer"
                className={styles["h-social"]}
              >
                <InstagramIcon />
              </a>
            </div>
          </div>

          {/* right side */}
          <div className={styles["h-right"]}>
            <img
              src={heroImg}
              alt="Sreerag V S"
              className={styles["h-hero-img"]}
            />
          </div>
        </div>

        {/* scroll hint */}
        <div
          className={styles["h-scroll"]}
          onClick={() =>
            document
              .getElementById("about")
              ?.scrollIntoView({ behavior: "smooth" })
          }
        >
          <div className={styles["h-scroll-mouse"]}>
            <div className={styles["h-scroll-dot"]} />
          </div>
          <span className={styles["h-scroll-lbl"]}>Scroll</span>
        </div>
      </section>
    </>
  );
}
